import { render, staticRenderFns } from "./customManage.vue?vue&type=template&id=040842da&scoped=true&"
import script from "./customManage.vue?vue&type=script&lang=js&"
export * from "./customManage.vue?vue&type=script&lang=js&"
import style0 from "./customManage.vue?vue&type=style&index=0&id=040842da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040842da",
  null
  
)

export default component.exports